// extracted by mini-css-extract-plugin
export var miniMap = "miniClimateMap-module--miniMap--WSjJP";
export var miniMapInner = "miniClimateMap-module--miniMapInner--wPkSt";
export var slideUp = "miniClimateMap-module--slideUp--NsWpz";
export var slideUpLarge = "miniClimateMap-module--slideUpLarge--OiQjb";